import script from "./GenericCameraUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./GenericCameraUpload.vue?vue&type=script&setup=true&lang=js"

import "./GenericCameraUpload.vue?vue&type=style&index=0&id=45cd157a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45cd157a"]])

export default __exports__